import React, { FC, useMemo, useRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  Export,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { MONEY_FORMAT } from 'constants/formats';
import $createStore from 'utils/create-store-instance';
import { onExporting } from 'utils/exportingExcel';

import { CreateEditModal, DeleteModal } from './components';

type Props = {
  cashFlowId: number | string;
  refreshForm: () => void;
};

const ChangeCashFlowIncomeSellingDetail: FC<Props> = ({ cashFlowId, refreshForm }) => {
  const refGrid = useRef<DataGrid | null>(null);

  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [detailId, setDetailId] = useState<number | null>(null);

  const dataSource: any = useMemo(() => {
    return $createStore(`/v1/CashFlowIncomeSelling/${cashFlowId}/details`, 'id');
  }, [cashFlowId]);

  const refresh = () => {
    refGrid.current?.instance.refresh();
    refreshForm();
  };

  return (
    <div className="container-dev">
      <div className="pr-2 pt-1">
        <AppLayoutTop title="">
          <ClaimsProvider claimsBlock={['CanCreateIncomeSellingDetails']}>
            <Button
              width={120}
              text="Добавить"
              type="default"
              onClick={() => {
                setDetailId(null);
                setModalIsVisible(true);
              }}
            />
          </ClaimsProvider>
        </AppLayoutTop>
      </div>
      {modalIsVisible && (
        <CreateEditModal
          changeVisible={setModalIsVisible}
          id={detailId}
          refresh={refresh}
          visible={modalIsVisible}
          cashFlowId={+cashFlowId}
        />
      )}

      {modalIsVisibleDelete && (
        <DeleteModal
          changeVisible={setModalIsVisibleDelete}
          visible={modalIsVisibleDelete}
          refresh={refresh}
          detailId={detailId}
          cashFlowId={+cashFlowId}
        />
      )}

      <AppCard>
        <DataGrid
          dataSource={dataSource}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          onExporting={onExporting}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
        >
          <StateStoring enabled={true} type="localStorage" storageKey="ChangeCashFlowIncomeSellingDetail" />
          <Export enabled={true} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <Column dataField="requestId" caption="Номер заявки" width={120} />
          <Column dataField="contractorName" caption="Контрагент" />
          <Column dataField="sum" caption="Сумма по заявке, руб." format={MONEY_FORMAT} />
          <Column dataField="receivedSum" caption="Получено, руб." format={MONEY_FORMAT} />
          <Column
            dataField="receivedSum"
            caption="Остаток, руб."
            cellRender={(data) => <>{(data.data.sum - data.data.receivedSum).toLocaleString()}</>}
          />
          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField="actions"
            caption=""
            width={120}
            allowFiltering={false}
            allowSorting={false}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditIncomeSellingDetails']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setDetailId(data.data.id);
                      setModalIsVisible(true);
                    }}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteIncomeSellingDetails']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setDetailId(data.data.id);
                      setModalIsVisibleDelete(true);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default ChangeCashFlowIncomeSellingDetail;
